import { Lock, Shield, AlertTriangle, Clock } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const ApiSecurityHeroSection = () => {
  return (
    <section className="pt-24 pb-8 sm:pt-28 sm:pb-10">
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <Badge variant="outline" className="text-primary border-primary/30 bg-primary/5">
          <Lock className="w-3 h-3 mr-1" />
          Development
        </Badge>
        <Badge variant="outline" className="text-muted-foreground border-border">
          12 min read
        </Badge>
      </div>

      <h1 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-foreground leading-tight mb-4">
        API Security: Authentication,{" "}
        <span className="text-primary">Rate Limiting</span> & Beyond
      </h1>

      <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-3xl mb-8">
        Comprehensive guide to securing REST and GraphQL APIs including JWT best practices, 
        rate limiting strategies, input sanitization, and preventing injection attacks.
      </p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Shield className="w-6 h-6 text-primary mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">94%</div>
          <div className="text-sm text-muted-foreground">Apps have API vulns</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <AlertTriangle className="w-6 h-6 text-destructive mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">3x</div>
          <div className="text-sm text-muted-foreground">Attack increase YoY</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Lock className="w-6 h-6 text-chart-4 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">OWASP 10</div>
          <div className="text-sm text-muted-foreground">Top risks covered</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Clock className="w-6 h-6 text-chart-2 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">287 days</div>
          <div className="text-sm text-muted-foreground">Avg breach detection</div>
        </div>
      </div>
    </section>
  );
};
